import { Injectable } from '@angular/core';
import { of, Observable, catchError } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { HttpClient } from '@angular/common/http';
import { UserTypes } from '../models/userTypes';


@Injectable({
  providedIn: 'root'
})
export class UserService {
  
  constructor(
    private envService: EnvironmentService,
    private http: HttpClient,
  ) { }

  getBaseUrl(role: UserTypes){
    switch(role){
        case UserTypes.EMA:
            return this.envService.environment.emApiGatewayURL+"/em-app";
        case UserTypes.SAM:
            return this.envService.environment.samBaseUrl;
        default:
            return this.envService.environment.emApiGatewayURL;
    }
  }


  getEvaluatorPermissions(role: UserTypes): Observable<any> { 
    let baseUrl = this.getBaseUrl(role);
    return this.http.get(baseUrl + '/v1/person/originality')
        .pipe(
          catchError((err:any) => {
            return of({admin:false});
            // CZ: think about calling the error service from here
          }));
  }
}
